import { styled } from '@mui/material';

export const JConfirmationBarStyled = styled('div')(({ theme }) => ({
  height: 52,
  width: '100%',
  position: 'fixed',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(4),
  top: 0,
  left: 0,
  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(2px)',
  WebkitBackdropFilter: 'blur(2px)',
  border: '1px solid rgba(255, 255, 255, 0.35)',
}));
